// Generated by CoffeeScript 2.7.0
Skylark.App.Controllers = (function() {
  var __controllers;
  __controllers = {};
  return new Object({
    register: function(controller) {
      var controller_class, controller_name;
      for (controller_name in controller) {
        controller_class = controller[controller_name];
        __controllers[controller_name.replace(/__/g, '::')] = controller_class;
      }
      return this;
    },
    find: function(controller_name) {
      return __controllers[controller_name];
    }
  });
})();
